export var SignInModeData;
(function (SignInModeData) {
    SignInModeData["CODE"] = "code";
    SignInModeData["EMAIL"] = "email";
    SignInModeData["PASSWORD"] = "password";
})(SignInModeData || (SignInModeData = {}));
//# sourceMappingURL=sign-in-mode-data.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/sign/sign-in-mode-data.js
// module id = 501
// module chunks = 14